import script from "./EmpresaAtivaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./EmpresaAtivaSelect.vue?vue&type=script&setup=true&lang=js"

import "./EmpresaAtivaSelect.vue?vue&type=style&index=0&id=11f50718&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f50718"]])

export default __exports__